import { Provider } from "@angular/core";
import "./registerChartjsElements";
import * as services from "./services";

export function provideCharting(): Array<Provider>
{
    return [
        services.OrgChartService,
        services.ChartRegistryService
    ];
}
